import React from "react";
import { five, four, green, hero, landing, one, p1, p2, p3, placeholder, three, two } from "../utils"; // Replace with your actual image import
import Footer from '../components/Footer';

const About = () => {
      const gallery = [
        {
          img: green,
        },
        {
          img: one,
        },
        {
          img: two,
        },
        {
          img: three,
        },
        {
          img: four,
        },
        {
          img: five,
        },
        {
          img: p1,
        },
        {
          img: p2,
        },
        {
          img: p3,
        },
      ];


  return (
    <div className="min-h-screen bg-black text-white py-20 px-8 space-y-20">
      {/* About Section */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Text Section */}
        <div>
          <h1 className="text-5xl font-bold mb-6">Über uns</h1>
          <p className="text-lg mb-4 leading-relaxed">
            Wir sind ein kreatives Team, das sich darauf spezialisiert hat,
            digitale Erlebnisse zu schaffen, die beeindrucken und inspirieren.
            Unser Ziel ist es, innovative und maßgeschneiderte Lösungen für
            Unternehmen und Marken zu entwickeln, die nicht nur funktional sind,
            sondern auch begeistern.
          </p>
          <p className="text-lg mb-4 leading-relaxed">
            Mit einem starken Fokus auf Design, Technologie und
            Benutzererfahrung setzen wir Trends und bieten unseren Kunden
            nachhaltige Resultate. Wir glauben daran, dass großartiges Design
            der Schlüssel zu erfolgreicher Kommunikation ist.
          </p>
        </div>
        {/* Image Section */}
        <div>
          <img
            src={landing}
            alt="Über uns"
            className="w-full h-auto object-cover rounded-md shadow-lg"
          />
        </div>
      </div>

      {/* Unser Spa Section with White Background */}
      <div className="bg-white text-black py-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold">Unser Spa</h2>
            <p className="text-xl text-gray-700 mt-4">
              Entdecken Sie unseren einzigartigen Spa-Bereich, in dem
              Entspannung und Erneuerung auf Sie warten.
            </p>
          </div>

          {/* Mini Gallery */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-8">
            {gallery.map((obj, index) => (
              <div key={index}>
                <img
                  src={obj.img}
                  alt={`Spa ${index + 1}`}
                  className="w-full h-64 object-cover rounded-md shadow-lg"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default About;
